import i18n from "../../i18n";
import React from "react";
import { Table, Text } from "@mantine/core";
import moment from "moment";

const AgingReportView = ({ rows = [] }) => (
  <>
    <Table striped withBorder>
      <thead>
        <tr>
          <th>{i18n.t("Counterparty")}</th>
          <th>{i18n.t("Document")}</th>
          <th>{i18n.t("Entry Date")}</th>
          <th>{i18n.t("Days")}</th>
          <th>{i18n.t("Bucket")}</th>
          <th>{i18n.t("Open Amount")}</th>
          <th>{i18n.t("Status")}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row._id || `${row.documentCode}-${row.entryDate}`}>
            <td>{row.counterpartyLabel}</td>
            <td>{row.documentCode}</td>
            <td>{row.entryDate ? moment(row.entryDate).format("LL") : ""}</td>
            <td>{row.days}</td>
            <td>{row.bucket}</td>
            <td>{row.openAmount}</td>
            <td>{row.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    {rows.length === 0 && (
      <Text size="sm" color="dimmed" mt="md">
        No aging data for the selected criteria.
      </Text>
    )}
  </>
);

export default AgingReportView;
